(function (exports) {
    "use strict";

    exports.CONTROL_PORTAL_URL = "https://control.dev.ctl.io";
    exports.CLC_V2_API_URL = "https://api.dev.ctl.io";
}(typeof exports === "undefined" ? this.Environment = {} : exports));


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/js/environment.jasset
 ** module id = 993
 ** module chunks = 0
 **/